
const banner = "<pre class='banner'>" +
  "  ▄▄▄▄   ▄▄▄    ▄▄▄   ▄▄▄▄   ▄▄▄   ▄▄▄  ▄▄▄▄▄▄▄  ▄▄▄▄▄▄▄ ▄▄▄▄▄▄▄▄▄ ▄▄▄   ▄▄▄    ▄▄▄▄▄▄▄   ▄▄▄▄▄   ▄▄▄▄▄▄▄   ▄▄▄    ▄▄▄  ▄▄▄▄▄▄▄ ▄▄▄▄▄▄▄\n"+
  "▄██▀▀██▄ ████▄  ███ ▄██▀▀██▄ ███   ███ ███▀▀▀▀▀ █████▀▀▀ ▀▀▀███▀▀▀ ███   ███   ███▀▀▀▀▀ ▄███████▄ ███▀▀███▄ ████▄  ███ ███▀▀▀▀▀ ███▀▀███▄\n"+
  "███  ███ ███▀██▄███ ███  ███ █████████ ███▄▄     ▀████▄     ███    ▀███▄███▀   ███      ███   ███ ███▄▄███▀ ███▀██▄███ ███▄▄    ███▄▄███▀\n"+
  "███▀▀███ ███  ▀████ ███▀▀███ ███▀▀▀███ ███         ▀████    ███      ▀███▀     ███      ███▄▄▄███ ███▀▀██▄  ███  ▀████ ███      ███▀▀██▄\n"+
  "███  ███ ███    ███ ███  ███ ███   ███ ▀███████ ███████▀    ███       ███      ▀███████  ▀█████▀  ███  ▀███ ███    ███ ▀███████ ███  ▀███\n"+
'</pre>';

const helpDescription =
  '<p class="command">fortune       --get a fortune cookie message<p>\n' +
  '<p class="command">advice        --get a random piece of advice<p>\n' +
  '<p class="command">badadvice     --get a random piece of bad advice<p>\n' +
  '<p class="command">howtouse      --how to use this terminal<p>\n' +
  '<p class="command">banner        --see the site logo<p>\n' +
  '<p class="command">clear         --clear terminal<p>\n' +
  '<p class="command">history       --view command history<p>\n' +
  '<p class="command">help          --see list of commands<p>\n';

export const listOfCommands = {
  "help": helpDescription,
  "banner": banner
}
